import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TextInput, Services, Modal, i18n, tokens, Text, BubbleSelectBlock } from '@simplybenefits/sb-ui-library';

import { updateAdminSettings } from '../../../actions/admin.js';
import FormControl from "@mui/material/FormControl";

class AdminSettings extends Component {
    state = {
        firstname: '',
        lastname: '',
        email: '',
        language: '',
        showModal: false,
        useMFA: false
    };

    componentDidMount() {
        const { meta } = this.props;

        this.setState({
            firstname: meta.firstname,
            lastname: meta.lastname,
            email: meta.email,
            useMFA: meta.useMFA,
            language: meta.language === "fr" ? "Français" : "English"
        });
    }

    _onBlur = async (type) => {
        this.setState({
            [`${ type }Error`]: await Services.validateInput(type, this.state[type])
        });
    };

    _handleInputChange = (type, event, isValue = false) => {
        this.setState({
            [type]: isValue ? event : event.target.value.trim()
        });
    };

    _confirm = async () => {
        const firstnameError = await Services.validateInput('firstname', this.state.firstname);
        const lastnameError = await Services.validateInput('lastname', this.state.lastname);
        const emailError = await Services.validateInput('email', this.state.email);

        this.setState({
            firstnameError,
            lastnameError,
            emailError
        });

        if (
            firstnameError ||
            lastnameError ||
            emailError
        ) {
            return false;
        }

        const body = {
            firstname: this.state.firstname,
            lastname: this.state.lastname,
            email: this.state.email,
            useMFA: Boolean(this.state.useMFA),
            language: this.state.language === "Français" ? "fr" : "en"
        };

        const success = this.props.dispatch(updateAdminSettings(body));

        if (success) {
            this.props.hideModal();
        }

        return null;
    };

    render() {
        const { hideModal, showModal } = this.props;

        return (
            <Modal
                open={showModal}
                onClose={hideModal}
                title={ i18n.t(tokens.labels.account.modifyDetails) }
                primaryButton={{
                    onClick: this._confirm
                }}
                loader={this.props.loader}
            >
                <TextInput
                    label={ i18n.t(tokens.labels.firstname) }
                    value={this.state.firstname}
                    onBlur={() => this._onBlur('firstname')}
                    onChange={(value) => this._handleInputChange('firstname', value)}
                    error={Boolean(this.state.firstnameError)}
                    helperText={this.state.firstnameError}
                    fullWidth
                    autofocus
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            this._confirm();
                            e.preventDefault();
                        }
                    }}
                />

                <TextInput
                    label={ i18n.t(tokens.labels.lastname) }
                    value={this.state.lastname}
                    onBlur={() => this._onBlur('lastname')}
                    onChange={(value) => this._handleInputChange('lastname', value)}
                    error={Boolean(this.state.lastnameError)}
                    helperText={this.state.lastnameError}
                    fullWidth
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            this._confirm();
                            e.preventDefault();
                        }
                    }}
                />

                <TextInput
                    label={ i18n.t(tokens.labels.email) }
                    value={this.state.email}
                    onBlur={() => this._onBlur('email')}
                    onChange={(value) => this._handleInputChange('email', value)}
                    error={Boolean(this.state.emailError)}
                    helperText={this.state.emailError}
                    fullWidth
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            this._confirm();
                            e.preventDefault();
                        }
                    }}
                />

                <TextInput
                    label={ i18n.t(tokens.labels.signup.language) }
                    value={ this.state.language }
                    onBlur={() => this._onBlur('language')}
                    onChange={(value) => this._handleInputChange('language', value)}
                    select
                    selectOptions={ Services.selectFieldOptions.languageOptionsNotTranslated() }
                    fullWidth
                />

                <FormControl component="fieldset">
                    <Text
                        medium
                        light
                        margin="20px 0 0px 0"
                    >
                        { i18n.t(tokens.labels.account.enforceMFA) }
                    </Text>

                    <Text
                        tiny
                        light
                        margin="5px 0 5px 0"
                    >
                        { i18n.t(tokens.labels.account.enforceMFAMessage) }
                    </Text>

                    <BubbleSelectBlock
                        disabled={ this.props.meta.enforceMFA }
                        first={{
                            title: i18n.t(tokens.labels.yes),
                            selected: this.props.meta.enforceMFA || Boolean(this.state.useMFA) === true,
                            field: 'enforceMFAYes'
                        }}
                        second={{
                            title: i18n.t(tokens.labels.no),
                            selected: !this.props.meta.enforceMFA && Boolean(this.state.useMFA) === false,
                            field: 'enforceMFANo'
                        }}
                        onBlur={(e) => this._onBlur('useMFA', e)}
                        handleChange={ async (field) => {
                            if (field === 'enforceMFAYes') {
                                await this._handleInputChange('useMFA', true, true);
                            } else {
                                await this._handleInputChange('useMFA', false, true);
                            }
                        }}
                    />

                    {
                        Boolean(this.props.meta.enforceMFA) &&
                            <Text
                                tiny
                                light
                                margin="5px 0 5px 0"
                            >
                                { i18n.t(tokens.labels.account.mfaEnforcedByAccount) }
                            </Text>
                    }
                </FormControl>

                <span id="settings" />
            </Modal>
        );
    }
}

AdminSettings.propTypes = {
    meta: PropTypes.object
};

/**
 * @param state
 * @returns {{meta: null, loading: boolean}}
 */
const mapStateToProps = (state) => ({
    meta: state.admin.meta
});

export default connect(mapStateToProps)(AdminSettings);